const COMMERCETOOLS_IMAGE_ORIGIN = {
  url: 'https://images.cdn.europe-west1.gcp.commercetools.com',
  rel: 'preconnect',
} as const

const CONTENTFUL_IMAGE_ORIGIN = {
  url: 'https://images.ctfassets.net',
  rel: 'preconnect',
} as const

const ONETRUST_DOT_COM = {
  url: 'https://geolocation.onetrust.com',
  rel: 'preconnect',
}

const COOKIELAW_DOT_COM = {
  url: 'https://cdn.cookielaw.org',
  rel: 'preconnect',
}

export const createLinkHeader = () => {
  const links = [
    process.env.STATIC_CDN_URL
      ? ({
          url: process.env.STATIC_CDN_URL,
          rel: 'preconnect',
        } as const)
      : undefined,
    COMMERCETOOLS_IMAGE_ORIGIN,
    CONTENTFUL_IMAGE_ORIGIN,
    ONETRUST_DOT_COM,
    COOKIELAW_DOT_COM,
    process.env.API_URL_SERVER
      ? {
          url: process.env.API_URL_SERVER,
          rel: 'preconnect',
        }
      : undefined,
  ]

  return links
    .map(link => link && `<${link.url}>; rel=${link.rel}`)
    .filter(v => !!v)
    .join(', ')
}
